import Flatpickr from 'react-flatpickr'
import 'flatpickr/dist/themes/material_blue.css'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
const pickerClasses = [
  'cursor-pointer',
  'bg-calendar',
  'bg-[right_10px_top_10px]',
  'bg-[length:18px_18px]',
  'bg-no-repeat',
  'flex',
  'flex-row-reverse',
  'border',
  'outline-none',
  'text-gray-900',
  'text-sm',
  'rounded-lg',
  'block',
  'w-full',
  'p-2',
  'dark:bg-gray-700',
  'dark:border-gray-600',
  'dark:placeholder-gray-400',
  'dark:text-white',
  'dark:focus:ring-blue-500',
  'dark:focus:border-blue-500'
]
const ODateRangePicker = props => {
  const { t } = useTranslation()
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')

  const onChangeStartDate = ([date]) => {
    setStartDate(date)
    props?.handleDateChange(date, endDate)
  }
  const onChangeEndDate = ([date]) => {
    setEndDate(date)
    props.handleDateChange(startDate, date)
  }
  const handleReset = () => {
    setStartDate('')
    setEndDate('')
  }

  useEffect(() => {
    handleReset()
    if (props?.isReset) {
      props?.setIsReset(false)
    }
  }, [props?.isReset])

  return (
    // <div className='sm:flex items-center text-center sm:text-left px-3 md:px-4 xl:px-7 lg:px-5  md:py-5 py-4 md:py-8 border'>
    <>
      <div className=' relative flex items-center mb-3'>
        <label className='mx-2 text-[#B8BBBF] text-xs whitespace-nowrap'>
          {props?.taskStartDate ? t('TASK_START_DATE_TIME') : t('O_FROM')}
        </label>
        <Flatpickr
          className={pickerClasses.join(' ')}
          name='start_date'
          placeholder={t('O_START_DATE')}
          value={startDate}
          options={{
            maxDate: endDate,
            dateFormat: 'm-d-Y'
          }}
          onChange={onChangeStartDate}
        />
      </div>
      <div className='relative flex items-center mb-3'>
        <label className='mx-2 text-[#B8BBBF] text-xs whitespace-nowrap'>
          {props?.taskEndDate ? t('TASK_END_DATE_TIME') : t('O_TO')}
        </label>
        <Flatpickr
          className={pickerClasses.join(' ')}
          name='end_date'
          placeholder={t('O_END_DATE')}
          value={endDate}
          options={{
            minDate: startDate,
            dateFormat: 'm-d-Y'
          }}
          onChange={onChangeEndDate}
        />
      </div>
    </>
    // </div>
  )
}

export default ODateRangePicker
